// extracted by mini-css-extract-plugin
module.exports = {"unstyledList":"collapsed-subjects_unstyledList__KGJjm"};